import { useEffect, useState } from 'react'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'
import { IServiceLocation } from '../typings'

export const useGetLocationOnMount = (locationId: string | null) => {
  const [serviceLocation, setLocation] = useState<IServiceLocation>()

  const [loadingStatus, setLoadingStatus] = useState<boolean>(false)

  useEffect(() => {
    const baseUrl = `${ServiceConfig.baseAPIUrl}/location`
    const execute = async () => {
      if (locationId) {
        try {
          setLoadingStatus(true)
          const response = await get(`${baseUrl}/core/${locationId}`)
          if (response.ok) {
            const location: IServiceLocation = await response.json()
            setLocation(location)
          }

          setLoadingStatus(false)
        } catch (error) {
          console.error(error)
        } finally {
          setLoadingStatus(false)
        }
      }
    }
    execute()
  }, [locationId])

  return { serviceLocation, loadingStatus }
}
